import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { MonthCalendar } from '../../components/shared/MonthCalendar';
import { Button } from '../../components/ui/Button';
export function AdminCalendar() {
  const {
    events,
    today
  } = useApp();
  return <div className="space-y-5" data-id="element-700" data-mp="3kzm2alcyduwz">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-701" data-mp="3g112gn1m5d92">
        <div data-id="element-702" data-mp="3g2c7srapit2a">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-703" data-mp="3g2vpc6wg3ffs">Koledar</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-704" data-mp="3b8rhllfcv3dn">Vsi dogodki zbora v sezoni 2026/27.</p>
        </div>
        <Link to="/admin/dogodki/nov" data-id="element-705" data-mp="36brdhg22gap6">
          <Button data-id="element-706" data-mp="329wb088efr9t">
            <PlusIcon className="h-4 w-4" data-id="element-707" data-mp="32afh8roosr80" />
            Nov dogodek
          </Button>
        </Link>
      </div>

      <MonthCalendar events={events} detailBase="/admin/dogodki" today={today} data-id="element-708" data-mp="2x9i2kp2vyfb9" />
    </div>;
}